import floor from "../Assets/services/tiling.JPG";
import painting from "../Assets/services/painting.jpg";
import waterproof from "../Assets/services/water.JPG";
import plumbing from "../Assets/services/plumbing.jpg";
import safety from "../Assets/services/safe.JPG";
import hvac from "../Assets/services/hvacsystem.jpg";
import auto from "../Assets/services/automationmain.JPG";
import renovation from "../Assets/services/renovation.jpg";
import carpentry from "../Assets/services/carpentr.JPG";
import AdditionalServices from "../Assets/services/additionalworks.JPG";
import electro from "../Assets/services/electro.png";
import medical from '../Assets/services/medical.jpg'

export const servicesList = [
  {
    ServiceName: "Flooring Solutions",
    Image: floor,
    desc: " We offer flooring solutions that combine style and durability, from hardwood to tiles. Our experts ensure quality installation and repair to enhance your spaces."
  },
  {
    ServiceName: "Electro-Mechanical Services",
    Image: electro,
    desc: "Our  Electro-Mechanical Services ensure safe and efficient system operation, from installation to repairs. We provide reliable solutions for homes, offices, and industrial spaces."
  },
  {
    ServiceName: "Painting & Decorative Works",
    Image: painting,
    desc: " Enhance your property’s appeal with our Painting & Decorative Works services. From fresh paint to custom finishes, we deliver solutions that add beauty and protection."
  }
  ,
  {
    ServiceName: "Medical Equipment Maintenance Services",
    Image: medical,
    desc: " We offer comprehensive Medical Equipment Maintenance Services to ensure the reliability and optimal performance of your equipment. we are here to fullfil your healthcare facility needs"
  },
  {
    ServiceName: "Water Proofing Solutions",
    Image: waterproof,
    desc: " Our Waterproofing & Exterior Protection services ensure the longevity of your property by preventing water damage and safeguarding structures from harsh weather elements."
  },
  {
    ServiceName: "Plumbing & Water Systems",
    Image: plumbing,
    desc: "  Our Plumbing & Water Systems services include installation, repair, and maintenance for all setups. From homes to industrial properties, we ensure smooth and reliable water flow."
  },
  {
    ServiceName: "Safety & Fire Protection",
    Image: safety,
    desc: " Our Safety & Fire Protection services keep your property secure from fire hazards and emergencies.We provide reliable solutions for ultimate safety and peace of mind."
  },
  {
    ServiceName: "HVAC Systems",
    Image: hvac,
    desc: "Our HVAC Systems services ensure the efficient management of indoor climates, making your spaces more comfortable, energy-efficient, and environmentally friendly."
  },
  {
    ServiceName: "Automation & Smart Solutions",
    Image: auto,
    desc: "Our Automation & Smart Solutions help modernize your property with the latest technology, ensuring convenience, efficiency, and security."
  },
  {
    ServiceName: "Renovation & Fit-Out Services",
    Image: renovation,
    desc: "Our Renovation & Fit-out Services help transform your space to meet your evolving needs, whether you’re refreshing a room or undertaking a full-scale renovation."
  },
  {
    ServiceName: "Carpentry & Fabrication",
    Image: carpentry,
    desc: " Our Carpentry & Fabrication services deliver custom woodworking and metalwork tailored to your needs.From furniture to structural, we craft solutions for your need."
  },
  {
    ServiceName: "Additional Services",
    Image: AdditionalServices,
    desc: " We provide a variety of additional services customized to meet our clients' unique needs. These complement our primary offerings for a complete solution for your needs."
  }
];
